<template>
  <section class="about-section">
    <div class="container">
      <div class="about-content">
        <h2 class="section-title">Tentang Kami</h2>
        <v-row>
          <v-col cols="12" md="6">
            <v-card class="about-card" flat>
              <v-card-text>
                <h3 class="about-subtitle">PT. Bathi Dua Putra</h3>
                <p class="about-text">
                  Merupakan perusahaan yang fokus pada bidang pengiriman barang
                  dalam negeri untuk melayani pelanggan di Indonesia.
                </p>
                <p class="about-text">
                  Dengan didukung Sumber Daya Manusia yang memiliki keahlian dan
                  pengalaman, Kami yakin dapat memberikan pelayanan yang terbaik
                  serta terus menerus melakukan inovasi dan beradaptasi dengan
                  perkembangan global.
                </p>
                <p class="about-text highlight">
                  BDP hadir untuk memberikan layanan pengiriman yang terbaik
                  dengan komitmen, tepat dan handal.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="vision-mission-card" flat>
              <v-card-text>
                <div class="vision-section">
                  <h3 class="vm-title">Visi</h3>
                  <p class="vm-text">
                    Komitmen untuk memberikan pelayanan terbaik tepat dan dapat
                    diandalkan bagi pelanggan
                  </p>
                </div>
                <div class="mission-section">
                  <h3 class="vm-title">Misi</h3>
                  <ul class="mission-list">
                    <li>
                      Menjadi perusahaan jasa pengiriman terdepan yang melayani
                      pengangkutan barang melalui darat, udara, dan laut dengan
                      komitmen, tepat, dan handal
                    </li>
                    <li>
                      Menciptakan Lingkungan Kerja yang aman dan nyaman agar
                      tercipta SDM yang profesional dan kompetitif
                    </li>
                  </ul>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-6">
          <v-col cols="12" sm="6" md="4" class="text-center">
            <v-btn
              color="primary"
              @click="Download"
              elevation="2"
              x-large
              class="download-btn"
            >
              <v-icon left>mdi-download</v-icon>
              Download Company Profile
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div>
      <a :href="whatsappLink" class="whatsapp-button">
        <i class="fab fa-whatsapp"></i> Hubungi Kami di WhatsApp
      </a>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AboutView",
  whatsappLink:
    "https://api.whatsapp.com/send?phone=6289654367407&text=*Hai%20Admin%20Saya%20mau%20tanya%20tentang%20pengiriman%20barang%20nih%2C%20Saya%20dapat%20wa%20nya%20dari%20Web%20nya%20bdpcargo.co.id%20Terima%20kasih*",
  components: {},
  methods: {
    async Download() {
      try {
        const fileUrl = "https://bdpcargo.co.id/doc/Company_Profile_BDP.pdf";
        window.open(fileUrl, "_blank");
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
// Add these styles to your existing <style> section
.about-section {
  padding: 80px 0;
  background-color: #fff;
}

.section-title {
  text-align: center;
  font-size: 36px;
  color: #333;
  margin-bottom: 40px;
}

.about-subtitle {
  font-size: 24px;
  color: #2c5282;
  margin-bottom: 20px;
}

.about-text {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
  color: #4a5568;
}

.highlight {
  color: #2c5282;
  font-weight: 600;
}

.vm-title {
  font-size: 24px;
  color: #2c5282;
  margin-bottom: 15px;
}

.vm-text {
  font-size: 16px;
  line-height: 1.6;
  color: #4a5568;
}

.mission-list {
  list-style-type: none;
  padding: 0;

  li {
    font-size: 16px;
    line-height: 1.6;
    color: #4a5568;
    margin-bottom: 15px;
    padding-left: 20px;
    position: relative;

    &:before {
      content: "•";
      color: #2c5282;
      position: absolute;
      left: 0;
    }
  }
}

.vision-section {
  margin-bottom: 30px;
}

.about-card,
.vision-mission-card {
  height: 100%;
  padding: 20px;
}
.download-btn {
  width: 100%;
  padding: 20px !important;
  font-size: 16px !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
  background: linear-gradient(45deg, #2c5282, #3182ce) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(44, 82, 130, 0.3) !important;
  }

  .v-icon {
    margin-right: 8px;
  }
}
.whatsapp-button {
  background-color: #25d366; /* Warna latar belakang WhatsApp */
  color: #fff; /* Warna teks */
  display: inline-block;
  padding: 10px 20px;
  border-radius: 30px; /* Untuk membuat tombol berbentuk bulat */
  text-decoration: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* Efek bayangan */
}

.whatsapp-button i {
  margin-right: 10px; /* Jarak antara ikon dan teks */
}
</style>
